import { render, staticRenderFns } from "./MaterializeNotification.vue?vue&type=template&id=2764a3d6&"
import script from "./MaterializeNotification.vue?vue&type=script&lang=js&"
export * from "./MaterializeNotification.vue?vue&type=script&lang=js&"
import style0 from "./MaterializeNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports